import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CheckCircle2Icon, ExternalLinkIcon, SearchIcon, TrendingUpIcon, ZapIcon } from 'lucide-react';
const FEATURES = [{
  icon: <SearchIcon className="w-4 h-4 text-emerald-400" data-id="element-156" data-mp="1efu68x58ibvo" />,
  label: 'AI meta tags'
}, {
  icon: <ZapIcon className="w-4 h-4 text-emerald-400" data-id="element-157" data-mp="1jddjpuu3ykmk" />,
  label: 'Image optimization'
}, {
  icon: <TrendingUpIcon className="w-4 h-4 text-emerald-400" data-id="element-158" data-mp="15e4f7sf9leyf" />,
  label: 'Technical SEO fixes'
}];
export function LatestReleaseSection() {
  return <section className="section-padding bg-black relative" data-id="element-159" data-mp="1abe2b1f6lej3">
      <div className="text-center max-w-3xl mx-auto mb-12 relative z-10" data-id="element-160" data-mp="vh9fj67998ik">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full glass-card mb-6 border-[#D4AF37]/30 bg-[#D4AF37]/5" data-id="element-161" data-mp="10erjei6f0xjp">
          <span className="w-2 h-2 rounded-full bg-[#D4AF37] animate-pulse-glow" data-id="element-162" data-mp="2pvistnekt8vy" />
          <span className="text-sm font-medium text-gradient-gold" data-id="element-163" data-mp="2us98i9mgy2gu">
            Latest Release
          </span>
        </div>
        <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-164" data-mp="hi1iyi3bvbpw">
          Introducing SEO Suite
        </h2>
        <p className="text-xl text-gray-400" data-id="element-165" data-mp="ck9gwv8yy97z">
          Our newest Shopify app. Automate technical SEO and dominate search
          rankings.
        </p>
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-166" data-mp="mbdt5n79ffz4">
        <div className="group relative overflow-hidden rounded-3xl border border-emerald-500/20 bg-gradient-to-br from-emerald-900/15 via-[#0a0a0a] to-[#0a0a0a] p-1 hover:border-emerald-500/40 transition-colors duration-500" data-id="element-167" data-mp="3uq4l40rqr13f">
          <div className="absolute -top-24 -right-24 w-72 h-72 bg-emerald-500/10 rounded-full blur-[100px] pointer-events-none" data-id="element-168" data-mp="7ly8moybo6rv" />

          <div className="relative rounded-[23px] p-8 md:p-12 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-169" data-mp="3i9x5v6kkr1c">
            {/* Copy */}
            <div data-id="element-170" data-mp="1ez09zx5i0h3x">
              <div className="flex items-center gap-3 mb-4" data-id="element-171" data-mp="1ezjf2da1vb0j">
                <div className="w-12 h-12 rounded-xl bg-emerald-500/10 flex items-center justify-center border border-emerald-500/20" data-id="element-172" data-mp="1f12vq4zmbo2u">
                  <SearchIcon className="w-6 h-6 text-emerald-400" data-id="element-173" data-mp="gmnwlqrgsmtg" />
                </div>
                <h3 className="text-3xl font-bold text-white" data-id="element-174" data-mp="lmjrn0i6p3wv">SEO Suite</h3>
                <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 text-xs font-bold uppercase tracking-wider" data-id="element-175" data-mp="lkfo4jo766x4">
                  <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" data-id="element-176" data-mp="3p15yfaqtb64m" />
                  Live
                </span>
              </div>

              <p className="text-lg text-gray-400 mb-6 leading-relaxed" data-id="element-177" data-mp="1x886hfeotgx">
                The all-in-one SEO solution for Shopify. Smart meta tags, image
                optimization, and automated technical fixes, built to grow your
                organic traffic.
              </p>

              <ul className="flex flex-wrap gap-3 mb-8" data-id="element-178" data-mp="3adb5puct11rj">
                {FEATURES.map(feature => <li key={feature.label} className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-sm text-gray-300" data-id="element-179" data-mp="32utthgdjn8uv">
                    {feature.icon}
                    {feature.label}
                  </li>)}
              </ul>

              <div className="flex flex-wrap gap-4" data-id="element-180" data-mp="2ox553yk9pjl2">
                <a href="https://apps.shopify.com/seo-suite" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-emerald-500 text-white px-7 py-3.5 rounded-full font-bold hover:bg-emerald-400 transition-colors shadow-[0_0_30px_rgba(16,185,129,0.3)]" data-id="element-181" data-mp="2jwhhznz5tmw4">
                  Install on Shopify <ExternalLinkIcon className="w-4 h-4" data-id="element-182" data-mp="2146k68jd4f4v" />
                </a>
                <Link to="/seo-suite" className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full font-bold text-white border border-white/20 hover:bg-white/5 transition-colors" data-id="element-183" data-mp="1w5ljk8077tfw">
                  Learn more{' '}
                  <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-184" data-mp="53wh2vie03tj" />
                </Link>
              </div>
            </div>

            {/* Mini dashboard mockup */}
            <div className="relative" data-id="element-185" data-mp="3dhwnfl2wccxu">
              <div className="absolute inset-0 bg-emerald-500/10 blur-[80px] rounded-full" data-id="element-186" data-mp="3dgtuz8pxe2ft" />
              <div className="glass-card border-white/10 p-2 rounded-2xl relative z-10 shadow-2xl shadow-black/50" data-id="element-187" data-mp="3hjqhhail6ip1">
                <div className="bg-[#0A0A0A] rounded-xl overflow-hidden border border-white/5" data-id="element-188" data-mp="33l0kduvroj0o">
                  <div className="h-8 border-b border-white/10 flex items-center px-3 gap-1.5 bg-white/5" data-id="element-189" data-mp="38jldzbgik4g5">
                    <div className="w-2.5 h-2.5 rounded-full bg-red-500/50" data-id="element-190" data-mp="11svlfzfuolgg" />
                    <div className="w-2.5 h-2.5 rounded-full bg-yellow-500/50" data-id="element-191" data-mp="16qdxhyp5zgso" />
                    <div className="w-2.5 h-2.5 rounded-full bg-green-500/50" data-id="element-192" data-mp="2r8y9rnr03u4a" />
                  </div>
                  <div className="p-6" data-id="element-193" data-mp="2mawnktya3eol">
                    <div className="flex justify-between items-center mb-6" data-id="element-194" data-mp="2mc7tazbaawic">
                      <h4 className="text-base font-bold text-white" data-id="element-195" data-mp="3102n6j1136x0">
                        SEO Health Score
                      </h4>
                      <span className="text-emerald-400 bg-emerald-400/10 px-3 py-1 rounded-full text-sm font-bold border border-emerald-400/20" data-id="element-196" data-mp="2w6hp6qzfqcxt">
                        98/100
                      </span>
                    </div>
                    <div className="grid grid-cols-2 gap-3 mb-4" data-id="element-197" data-mp="3jyoonz0gj01g">
                      <div className="bg-white/5 p-3 rounded-lg border border-white/5" data-id="element-198" data-mp="3jw2ersq3g8g2">
                        <p className="text-xs text-gray-400 mb-1" data-id="element-199" data-mp="3eztyud42ob7u">
                          Organic Traffic
                        </p>
                        <p className="text-lg font-bold text-white flex items-center gap-1.5" data-id="element-200" data-mp="1klatm2s5btm4">
                          +145%
                          <TrendingUpIcon className="w-4 h-4 text-emerald-400" data-id="element-201" data-mp="2aa84qb3vt7q6" />
                        </p>
                      </div>
                      <div className="bg-white/5 p-3 rounded-lg border border-white/5" data-id="element-202" data-mp="2ecuqbu9ylwex">
                        <p className="text-xs text-gray-400 mb-1" data-id="element-203" data-mp="2j8jru35jhndv">
                          Images Optimized
                        </p>
                        <p className="text-lg font-bold text-white" data-id="element-204" data-mp="2t8anw99r0ag2">12,450</p>
                      </div>
                    </div>
                    <div className="space-y-2" data-id="element-205" data-mp="2x8ktvlxjj0ux">
                      {['Meta Tags Optimized', 'Broken Links Fixed'].map(item => <div key={item} className="flex items-center justify-between p-2.5 bg-emerald-500/10 rounded-lg border border-emerald-500/20" data-id="element-206" data-mp="36zfq9j4i3gu3">
                            <div className="flex items-center gap-2.5" data-id="element-207" data-mp="3gyohi47zehcr">
                              <CheckCircle2Icon className="w-4 h-4 text-emerald-400" data-id="element-208" data-mp="15a02cx9n9tkg" />
                              <span className="text-sm text-emerald-100" data-id="element-209" data-mp="10b6r7bhtyeng">
                                {item}
                              </span>
                            </div>
                            <span className="text-xs text-emerald-400" data-id="element-210" data-mp="vdx4w4pqmj3u">
                              Automated
                            </span>
                          </div>)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}